import { useParams } from "react-router-dom";
import { useState } from "react";
import { useNavigate } from "react-router";
import { Snackbar, Alert } from "@mui/material";

const Password = () => {  
  const navigate = useNavigate();
  const { resetId } = useParams();
  const [message, SetMessage] = useState("");
  const [password, SetPassword] = useState("");
  const [confirmation, SetConfirmation] = useState("");

  const Submit = (event: React.ChangeEvent<any>) => {
    event.preventDefault();

    // Verify password is present
    if (password.trim() === "") {
       SetMessage("Password has not been entered.");
      return;     
    }

    // Verify password confirmation matches
    if (password.trim() !== confirmation.trim()) {
      SetPassword("");
      SetConfirmation("");
      SetMessage("Password and password confirmation do not match.");
      return;
    }

    const values = {
      ResetId: resetId,
      Password: password.trim()
    }
    
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(values)
    };

    fetch("/api/password", options)
      .then(response => response.text())
      .then(data => {
        if (data === "OkE") {
          navigate("/");
        }
        if (data === "OkA") {
          navigate("/admin");
        }        
      })
      .catch(error => console.error(error));
  }

  const OnChange = (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target;
    if (name === "Password") {
      SetPassword(value);
    } else {
      SetConfirmation(value);
    }    
  }  

  return (
    <div className="login">
      <Snackbar open={message} onClose={() => SetMessage("")} anchorOrigin={{ vertical: "top", horizontal: "center" }} autoHideDuration={5000}>
        <Alert severity="error" variant="filled" sx={{ width: "100%", padding: 2 }}>
          {message}
        </Alert>
      </Snackbar>

      <header>
        <a href="#main" className="skip">Skip to main content</a>
        <div className="container">
            <div className="logo"><a href="/"><img src="/images/logo-login.jpg" alt="Rural Community Immigration Pilot Logo" /></a></div>
            <h1>RCIP Password Reset</h1>  
        </div>
      </header>      
      <section id="main">
        <div className="container">
          <form onSubmit={Submit}>
            <p>
              <label>New Password
                <input type="password" name="Password" onChange={OnChange} required />
              </label>
            </p>
            <p>
              <label>Password Confirmation
                <input type="password" name="Confirmation" onChange={OnChange} required />
              </label>
            </p>            
            <p className="formButton"><input type="submit" value="Set Password" /></p>
            <p className="formButton"><a href="/">Return to Sign In</a></p>
          </form>            
        </div>
      </section>
    </div>
  );
}

export default Password;